
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/collections/[collectionId]",
      function () {
        return require("private-next-pages/[domain]/collections/[collectionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/collections/[collectionId]"])
      });
    }
  